import { FormControlLabel, Radio, RadioGroup, withStyles } from '@material-ui/core';
import React from 'react';

const styles = (theme) => ({
  group: {
    display: 'flex',
    flexDirection: 'row'
  },
  label: {
    color: theme.TextColor
  },
  radioRoot: {
    color: theme.TextColor
  },
  radioChecked:{
    '&+$label':{
      fontSize: theme.headerTextFontSize16
    }
  }
});

export const VIEWS = {
  TERMINAL: {
    label: 'Terminal View',
    value: '1'
  },
  NETWORK: {
    label: 'Network View',
    value: '2'
  }
};

const ViewOptions = ({ classes, selectedView, onViewUpdate }) => {
  return (
    <RadioGroup
      aria-label="ViewOptions"
      className={classes.group}
      value={selectedView}
      onChange={onViewUpdate}>
      <FormControlLabel
        value={VIEWS.TERMINAL.value}
        control={<Radio classes={{ root: classes.radioRoot, checked: classes.radioChecked }} color="primary" />}
        label={VIEWS.TERMINAL.label}
        classes={{ label: classes.label }}
      />
      <FormControlLabel
        value={VIEWS.NETWORK.value}
        control={<Radio classes={{ root: classes.radioRoot ,checked: classes.radioChecked}} color="primary" />}
        label={VIEWS.NETWORK.label}
        classes={{ label: classes.label }}
      />
    </RadioGroup>
  );
};

export default withStyles(styles)(ViewOptions);
